module.exports = __webpack_public_path__ + "7dfea099cbaad8650239c6932f19a30d.png";